
import React, { useEffect, useState } from 'react'
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import * as Yup from "yup";
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import ExamCenters from './ExamCenters';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { useNavigate } from 'react-router-dom';
import { FaHandPointRight, FaPrint, FaWindowClose } from "react-icons/fa";
import Swal from 'sweetalert2';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { CONTEXT_NAME, ERROR_MSG } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { FaCircleChevronRight } from 'react-icons/fa6';
import Weboptions from '../WebOptions/Weboptions';
import { examCenterValidations } from '../../../CommonUtilities/Validations/Validations';
import Preview from './Preview';
import { useSelector } from 'react-redux';

export const mappings = {
    loc_1: "GOVERNMENT/LOCAL BODIES",
    open_1: "GOVERNMENT/LOCAL BODIES",
    loc_8: "TRIBAL WELFARE (ASHRAM)",
    open_8: "TRIBAL WELFARE (ASHRAM)",
    loc_4: 'AP SOCIAL WELFARE RESIDENTIAL SOCIETY (APSWRS)',
    open_4: 'AP SOCIAL WELFARE RESIDENTIAL SOCIETY (APSWRS)',
    loc_2: 'MUNICIPAL',
    open_2: 'MUNICIPAL',
    loc_11: "MUNICIPAL CORPORATION",
    open_11: "MUNICIPAL CORPORATION",
    loc_10: "JUVENILE WELFARE",
    open_10: "JUVENILE WELFARE",
    loc_5: 'AP MODEL SCHOOLS (APMS)',
    open_5: 'AP MODEL SCHOOLS (APMS)',
    open_9: 'MJP BC WELFARE RESIDENTIAL SCHOOLS (MJPBCWRS))',
    loc_9: 'MJP BC WELFARE RESIDENTIAL SCHOOLS (MJPBCWRS)',
    loc_3: 'APTWRS (GURUKULAS)',
    open_3: 'APTWRS (GURUKULAS)',
    open_6: "AP RESIDENTIAL EDUCATIONAL INSTITUTIONS (APREIS)",
    loc_6: 'AP RESIDENTIAL EDUCATIONAL INSTITUTIONS (APREIS)',
    open_7: "DIFFERENTLY ABLED WELFARE",
    loc_7: 'DIFFERENTLY ABLED WELFARE',
    // Add additional mappings as needed
};

export default function PostApplication() {
    let navigate = useNavigate()
    const [selectedPostCount, setSelectedPostCount] = useState(0);
    // balnced posts -------------------->
    const [previousPostCount, setPreviousPostCount] = useState(0)
    const [AlPaidPostCount, setAlPaidPost] = useState(0)
    function PreviousCountFunction() {
        let linkurl = config.url.DSC_URL + 'candidate-balance-posts'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data.status === true) {
                setPreviousPostCount(response?.data?.data[0]?.balance_pay)
                setAlPaidPost(response?.data?.data[0]?.alr_paid_posts)
            }
            else {
                setAlPaidPost(0);
                setPreviousPostCount(0);
            }
        })
    }
    function SelectedOptionsFunction(set) {
        let linkurl = config.url.DSC_URL + 'candidate-post-preferences'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data?.status === true) {
                let data_s = response?.data?.data;
                data_s?.forEach((data) => {
                    data.id = `${data?.management_id}999${data?.post_id}`;
                });
                set(data_s)
            }
        });
    }
    // et posts data -------------------->
    const [jsonData, setJsonData] = useState([]);
    const [postData, setPostData] = useState([]);
    const [OptionList, SetOptionList] = useState([])
    const [SelectedOption, SetSelectedOption] = useState([]);

    const getOptions = (distcode, data, set) => {
        const distCodeValue = distcode;

        let parsedDistricts = [];
        try {
            parsedDistricts = JSON.parse(data?.districts_json || "[]");
        } catch (e) {
            console.error("Invalid JSON in districts_json:", data?.districts_json);
            return;
        }

        const districtsArray = parsedDistricts[0];
        if (!Array.isArray(districtsArray)) {
            console.error("Expected an array in parsedDistricts[0]");
            return;
        }

        const districts = districtsArray.find((val) => String(val?.dist_code) === String(distCodeValue));

        if (!districts) {
            console.warn("District not found for dist_code:", distCodeValue);
            return;
        }

        let keysWithValuesGreaterThanZero;
        const sourceEntries = Object.entries(districts).filter(([key, value]) =>
            typeof value === "number" &&
            value > 0 &&
            !excludedKeys.includes(key) &&
            mappings[key]
        );

        if (districts?.local_not === "L") {
            const uniqueMap = new Map(
                sourceEntries
                    .filter(([key]) => key.startsWith('loc_') || key.startsWith('open_'))
                    .map(([key]) => {
                        const man_id = key.split('_')[1];
                        return [man_id, { name: mappings[key], man_id }];
                    })
            );
            keysWithValuesGreaterThanZero = Array.from(uniqueMap.values());
        } else {
            const uniqueMap = new Map(
                sourceEntries
                    .filter(([key]) => key.startsWith('open_'))
                    .map(([key]) => {
                        const man_id = key.split('_')[1];
                        return [man_id, { name: mappings[key], man_id }];
                    })
            );
            keysWithValuesGreaterThanZero = Array.from(uniqueMap.values());
        }

        const final_data = keysWithValuesGreaterThanZero?.map((item) => ({
            ...data,
            id: `${item?.man_id}999${data?.post_id}`,
            paid_dist_code: distCodeValue,
            paid_dist_name: districts?.dist_name || data?.paid_dist_name,
            management_id: item?.man_id,
            management_name: `${data?.eli_post_name}_${item?.name}_${districts?.dist_name}`
        }));

        // Filter duplicates based on management_name
        set((prev) => {
            const existingNames = new Set(prev.map((entry) => entry.management_name));
            const uniqueFinalData = final_data.filter(
                (entry) => !existingNames.has(entry.management_name)
            );
            return [...prev, ...uniqueFinalData];
        });
    };
   const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
   console.log("tabdetails",tabdetails)
    const [hideSubmit, setHideSubmit] = useState(false) // if it is true only submit btn appears .
    const [showOtp, setShowOtp] = useState(false)
    const getpostDataFunction = () => {
        let villUrl = config.url.DSC_URL + "candidate-posts";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                let data = response?.data?.candidateposts?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                let filterdata_len = data?.filter((val) => val.paid_dist_code !== null)?.length
                if (filterdata_len === data?.length) {
                    setHideSubmit(true)
                }
                setPostData(data)
                SelectedOptionsFunction(SetSelectedOption)
                let length = data?.length
                let newData = [];
                for (let i = 0; i < length; i++) {
                    newData.push(
                        {
                            postCheck: false,
                            postId: "",
                            pstType: "",
                            distCode: ""
                        });

                    setJsonData(newData);
                }
            }
            else {
                setJsonData([])
                setPostData([])
            }
        });
    };
    const ValidationSchema1 = Yup.object().shape({
        ...examCenterValidations.fields,
        // option1: Yup.string()
        //     .required(ERROR_MSG)
        //     .test('unique', 'Option  is already selected', (value, context) => {
        //         if (value !== "") {
        //             const { option2, option3, option4, option5 } = context.parent;
        //             return value !== option2 && value !== option3 && value !== option4 && value !== option5;
        //         }
        //         return true
        //     }),
        // option2: Yup.string()
        //     .required(ERROR_MSG)
        //     .test('unique', 'Option  is already selected', (value, context) => {
        //         if (value !== "") {
        //             const { option1, option3, option4, option5 } = context.parent;
        //             return value !== option1 && value !== option3 && value !== option4 && value !== option5;
        //         }
        //         return true
        //     }),
        // option3: Yup.string()
        //     .required(ERROR_MSG)
        //     .test('unique', 'Option  is already selected', (value, context) => {
        //         if (value !== "") {
        //             const { option2, option1, option4, option5 } = context.parent;
        //             return value !== option2 && value !== option1 && value !== option4 && value !== option5;
        //         }
        //         return true
        //     }),
        // option4: Yup.string()
        //     .required(ERROR_MSG)
        //     .test('unique', 'Option  is already selected', (value, context) => {
        //         if (value !== "") {
        //             const { option2, option3, option5, option1 } = context.parent;
        //             return value !== option2 && value !== option3 && value !== option5 && value !== option1;
        //         }
        //         return true
        //     }),
        // option5: Yup.string()
        //     .required(ERROR_MSG)
        //     .test('unique', 'Option  is already selected', (value, context) => {
        //         if (value !== "") {
        //             const { option2, option3, option4, option1 } = context.parent;
        //             return value !== option2 && value !== option3 && value !== option4 && value !== option1;
        //         }
        //         return true
        //     }),
        postDetails: Yup.array().of(Yup.object().shape({
            postCheck: Yup.boolean(),
            distCode: Yup.string().when("postCheck", {
                is: (postCheck) => (postCheck === true),
                then: Yup.string().required(ERROR_MSG).nullable(),
                oterwise: Yup.string().nullable(),
            }),
        })),
    })
    const ValidationSchema2 = Yup.object().shape({
        postDetails: Yup.array().of(Yup.object().shape({
            postCheck: Yup.boolean(),
            distCode: Yup.string().when("postCheck", {
                is: (postCheck) => (postCheck === true),
                then: Yup.string().required(ERROR_MSG).nullable(),
                oterwise: Yup.string().nullable(),
            }),
        }))
    })

    const [examCenterData, setExamCenterData] = useState([])
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            payment: 0,
            postDetails: jsonData,
            option1: "",
            option2: "",
            option3: "",
            option4: "",
            option5: "",
            otp: ''
        },
        validationSchema: examCenterData?.length > 0 ? ValidationSchema2 : ValidationSchema1,
        onSubmit: (values) => {
            // console.log("values",values)

            let totalvaluesCount = OptionList?.length;
            let check_length = values?.postDetails?.filter(val => val?.postCheck === true)?.length

            if (check_length === 0) {
                return Sweetalert('Please Check Atleast One Post', 'warning')
            }
            if (totalvaluesCount !== 0) {
                return Sweetalert('Please Select Post-Managements', 'warning')
            }
            sendOtp()
        },
    })
    function SubmitPostValues() {
        let values = Formik?.values;
        const updatedPostDetails = values?.postDetails
            ?.filter(val => val?.postCheck === true)
            ?.map(val => ({
                ...val,
                distCode: typeof val?.distCode === 'string' && val?.distCode?.startsWith('Z')
                    ? val.distCode.slice(1) // remove leading 'Z'
                    : val.distCode
            }));

        let filtereddetails = {
            payment: values?.payment,
            postDetails: updatedPostDetails,
            option1: values?.option1,
            option2: values?.option2,
            option3: values?.option3,
            option4: values?.option4,
            option5: values?.option5,
            postPref: [],
            otp: values?.otp
        }
        SelectedOption?.forEach((val, i) => {
            filtereddetails.postPref[i] = {
                postId: val.post_id,    // Correct assignment for cat
                preference: i + 1,         // Correct assignment for pref (starting at 1)
                managementId: val.management_id    // Assuming orgId comes from val
            };
        });
        let totalvaluesCount = OptionList?.length
        if (totalvaluesCount !== 0) {
            return Sweetalert('Please Select Post-Managements', 'warning')
        }
        if (showOtp === true && values?.otp !== "") {
            let url = config.url.DSC_URL + "candidate-post-details"
            Swal.fire({
                title: 'Are you Sure?',
                html: `You have selected for <b style="color: blue;">${filtereddetails?.postDetails?.length}</b> posts 
                ${filtereddetails?.payment > 0 ? `,<br/>You have already paid for<b style="color: blue;"> ${previousPostCount} </b>posts<br/>
                Now you need to pay <b style="color: green;">${filtereddetails?.payment} Rs. </b>for <b style="color: blue;">
                ${filtereddetails?.postDetails?.length - previousPostCount} post</b> ` : ``}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: filtereddetails?.payment > 0 ? 'Proceed to Pay' : 'Submit',
            }).then((res) => {
                if (res.isConfirmed) {
                    CommonAxiosPost(url, filtereddetails).then((res) => {
                        if (res?.data?.status === true) {
                            getExamDataFunction()
                            if (filtereddetails?.payment > 0) {
                                let link = res?.data?.paymentUrl
                                window.open(link, '_self');
                            }
                            else {
                                Swal.fire({
                                    title: 'Successfully Submitted',
                                    text: 'Please click the below "click here" button to upload the documents.',
                                    icon: "info",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: 'Click Here',
                                    cancelButtonText: 'Cancel',
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        navigate('/FileUploads');
                                        window.location.reload();
                                    } else if (res.dismiss === Swal.DismissReason.cancel) {
                                        window.location.reload();
                                    }
                                });
                                Swal.fire({
                                    title: 'Successfully Submitted',
                                    text: 'Please click the below "click here" button to upload the documents.',
                                    icon: "info",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: 'Click Here',
                                    cancelButtonText: 'Cancel',
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        navigate('/FileUploads');
                                        window.location.reload();
                                    } else if (res.dismiss === Swal.DismissReason.cancel) {
                                        window.location.reload();
                                    }
                                });

                            }
                        }
                        else {
                            Sweetalert(res?.data?.sdesc, "error")
                        }
                    })
                }
            })
        }
        else {
            Sweetalert('Please Enter Otp to continue', 'warning')
        }
    }

    useEffect(() => {
        const count = Formik?.values?.postDetails?.filter((val) =>
            val?.postId !== "" && val?.postCheck === true).length || 0;
        if (count > 0) {
            setSelectedPostCount(count);
            let amount = (count - parseInt(previousPostCount)) * 750
            Formik.setFieldValue('payment', amount > 0 ? amount : 0)
        }
        else {
            setSelectedPostCount(0)
        }

    }, [Formik?.values])
    const [showOtpBtn, setOtpBtn] = useState(true);
    const [resendOtp, setResendOtp] = useState(false);
    function sendOtp() {

        Swal.fire({
            title: 'Are you Sure Want to Submit?',
            html: `Make Sure , OTP will be Send to your Mobile No.`, icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send OTP",
        }).then((res) => {
            if (res.isConfirmed) {
                let otpUrl = config.url.DSC_URL + "generate-post-pref-otp"
                CommonAxiosPost(otpUrl).then((rres) => {
                    if (rres?.data?.status === true) {
                        setShowOtp(true)
                        setOtpBtn(false)
                        setTimer(180);
                    }
                    else if (rres?.data?.scode === '03') {
                        Sweetalert(rres?.data?.sdesc, "warning")

                    } else {
                        Sweetalert('Internal Server Issue', "warning")
                    }

                })
            }
        })


    }
    const getExamDataFunction = () => {
        let villUrl = config.url.DSC_URL + "candidate-exam-center-details";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                let data = response.data.data
                setExamCenterData(response.data.data)
                Formik?.setFieldValue('option1', data[0]?.dist_code)
                Formik?.setFieldValue('option2', data[1]?.dist_code)
                Formik?.setFieldValue('option3', data[2]?.dist_code)
                Formik?.setFieldValue('option4', data[3]?.dist_code)
                Formik?.setFieldValue('option5', data[4]?.dist_code)

            }
            else {
                setExamCenterData([])
            }
        });
    };
    useEffect(() => { getpostDataFunction(); PreviousCountFunction(); getExamDataFunction(); SelectedOptionsFunction(SetSelectedOption) }, [])
    const handleClose = () => setShow(false);
    const [show, setShow] = useState(false);
    const [showMoreDist, setMoreDist] = useState([])
    const [postName, setPostName] = useState('')
    const excludedKeys = ["open_no_of_posts", "local_no_of_posts", "dist_code"];


    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer > 0) {
                        if (prevTimer < 122) {
                            setResendOtp(true);
                            return prevTimer - 1;
                        } else if (prevTimer > 1) {
                            return prevTimer - 1;
                        }
                        else {
                            clearInterval(interval);
                            setResendOtp(true); // Enable resend button when timer reaches 0
                            return 0;
                        }
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showOtpBtn]);

    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const resendOTP = () => {
        Formik.setFieldValue("otp", "")
        sendOtp()

    };
    const zones = [
        { "zone_id": 'Z1', distList: [1, 2, 3] },
        { "zone_id": 'Z2', distList: [4, 5, 6] },
        { "zone_id": 'Z3', distList: [7, 8, 9] },
        { "zone_id": 'Z4', distList: [10, 11, 12, 13] }
    ]
    const getZoneStatus = (zones, distCodeValue, zoneId) => {
        const zone = zones.find(val => val.zone_id === zoneId);
        return zone?.distList.includes(parseInt(distCodeValue));
    };

    const [showDist, setDist] = useState([]);
    function renderDistrictOptions(data, index) {
        const data_json = JSON.parse(data?.districts_json)?.[0] || [];

        if (data_json.length === 1) {
            setDist(prev => {
                const newArr = [...prev];
                newArr[index] = data_json;
                return newArr;
            });
            return;
        }

        // Step 1: Hide 'State' districts (post_type === 'S')
        const filteredWithoutState = data_json.filter(item => item.post_type !== 'S');

        // Step 2: Build filtered show list based on Zones and D-type districts
        const D_type_dists = data_json.filter(item => item.post_type === 'D');

        // Step 3: Identify zone_ids to hide (based on presence of D-type districts in zone's distList)
        const zone_ids_to_hide = zones
            .filter(zone => {
                return D_type_dists.some(d => zone.distList.includes(parseInt(d.dist_code)));
            })
            .map(zone => zone.zone_id);

        // Step 4: Remove zone-type districts (post_type === 'Z') whose zone_id is in zone_ids_to_hide
        const finalFiltered = filteredWithoutState.filter(item => {
            if (item.post_type === 'Z') {
                return !zone_ids_to_hide.includes(item.dist_code); // Z1, Z2, etc. are stored in dist_code
            }
            return true; // Keep others (like D-type)
        });

        // Step 5: Update showDist
        setDist(prev => {
            const newArr = [...prev];
            newArr[index] = finalFiltered;
            return newArr;
        });
    }

    //  const handleCloseee = () => setShowwww(false);
    //     const [showww, setShowwww] = useState(true);
          
        const handlepreviewClose = () => setpreviewShow(false);
        const [previewshow, setpreviewShow] = useState(() => {
            if (tabdetails?.latestTab === 3) {
                return tabdetails?.confirm === false;
            }
            return '';
        });
        
    return (
        <React.Fragment>
         <div className='pop pop-fix'>
                        {previewshow && <div className="background-hide"></div>}
                        <Modal size="xl" className='pop pop-fix' show={previewshow} onHide={() => { handlepreviewClose(); navigate(-1) }} backdrop="static"
                            style={{ maxWidth: '100%', width: '100%' }}
                        >
                            <Modal.Header style={{}} >
                                <Modal.Title>  {CONTEXT_NAME}</Modal.Title>
                                <button type="button" className='btn btn-end'
                                    onClick={() => {
                                        setpreviewShow(false);
                                        navigate(-1)
                                    }} style={{ fadeType: "out" }}
                                    variant="danger"
                                    aria-label="Close"><h4>
                                        <FaWindowClose className="text-danger" size={32} />
                                    </h4></button>
                            </Modal.Header>
                            <Modal.Body>
                                <Preview handleClose={handlepreviewClose} />
                            </Modal.Body>
                        </Modal>
                        </div>
            <FormikProvider value={Formik}>
                <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
                    <div className='pop'>
                        <Modal size="xl" className='' centered show={show} onHide={handleClose} backdrop="static" keyboard={false} >
                            <Modal.Header style={{ backgroundColor: "rgb(220 162 77)", height: "60px" }} >
                                <Modal.Title>{CONTEXT_NAME}</Modal.Title>
                                <button type="button" className='btn btn-end'
                                    onClick={() => {
                                        setShow(false)
                                    }} style={{ fadeType: "out" }}
                                    variant="danger"
                                    aria-label="Close"><h4>
                                        <FaWindowClose className="text-danger" size={32} />
                                    </h4></button>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="heading-main">
                                    <h3 className="main-title">Dist./Zone wise Available Posts - <span style={{ color: 'brown' }}>{postName}</span></h3>
                                </div>
                                <table className="table table-condensed table-bordered table-striped table-responsive"
                                    style={{ borderCollapse: 'collapse', border: '1px solid skyblue' }}>
                                    <thead style={{
                                        backgroundColor: '#dbe9f4'

                                    }}>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Dist./Zone</th>
                                            <th>Non-Local No. of Posts (Managements)</th>
                                            <th>Local No. of Posts (Managements)</th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {showMoreDist ? showMoreDist?.map((item, index) => {
                                            return (
                                                <tr key={index} id={index}>
                                                    <td>{index + 1}.</td>
                                                    <td>{item?.dist_name}</td>
                                                    <td>
                                                        {item?.open_no_of_posts > 0 ? <>
                                                            <b>{item?.open_no_of_posts} &nbsp;</b>
                                                            ({Object.entries(item).filter(([key, value]) => key.startsWith('open_') &&
                                                                typeof value === "number" && value > 0 && !excludedKeys.includes(key) &&
                                                                mappings[key]).map(([key, value]) => `${mappings[key].split('_')[0]} - ${value}`).join(', ')}
                                                            )
                                                        </>
                                                            : <span className='text-center'>-</span>}
                                                    </td>
                                                    <td>

                                                        <b>{item?.local_not === 'L' && item?.local_no_of_posts}&nbsp;</b>
                                                        {item?.local_not === 'L' ? (<>
                                                            ({Object.entries(item)
                                                                .filter(([key, value]) =>
                                                                    key.startsWith('loc_') &&
                                                                    typeof value === "number" &&
                                                                    value > 0 &&
                                                                    !excludedKeys.includes(key) &&
                                                                    mappings[key]
                                                                )
                                                                .map(([key, value]) => `${mappings[key].split('_')[0]} - ${value}`)
                                                                .join(', ')

                                                            })
                                                        </>

                                                        ) : (
                                                            <span className='text-center'>-</span>
                                                        )}

                                                    </td>
                                                </tr>
                                            )
                                        }) : ''}
                                    </tbody>
                                </table>
                            </Modal.Body>

                        </Modal></div>

                    <div className='px-4 mt-4'>
                        <Row className='px-3'>
                            <Col xxl={9} xl={9} lg={9} md={9} sm={12} xs={12} className='mt-2'>
                                {previousPostCount > 0 ?
                                    <h5><span style={{ fontFamily: 'bold' }} className='text-danger'>NOTE : </span> You have made payment for&nbsp;
                                        <span style={{ color: 'red', fontFamily: 'bold' }}>{AlPaidPostCount}</span> no. of posts earlier,please select below
                                        eligible posts. </h5>
                                    : ''}
                            </Col>
                            <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className='text-end' >
                                <div className='mb-2 mt-4'><FaHandPointRight size={30} />&emsp;
                                    <i style={{ background: "#2a9d8f" }} className="badge badge-success forgot fw-bold" onClick={() => navigate('/PrintApplication', { state: { status: 'preview' } })} onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            navigate('/PrintApplication', { state: { status: 'preview' } })
                                        }
                                    }}
                                        data-toggle="tooltip" animation="true"
                                    > Preview / Print <FaPrint title="Print" style={{ fontSize: '22px' }} /></i>
                                </div>
                            </Col>
                        </Row></div>
                    <div className="personal-head ">
                        <span>Post Details</span>
                    </div>
                    <div className="personal-row pb-3">

                        <Row className='px-3'>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="mt-4 mt-xl-0">
                                <table className="table table-bordered table-responsive mb-0 mt-2"
                                    style={{ borderCollapse: 'collapse', border: '1px solid skyblue' }}>
                                    <thead style={{
                                        backgroundColor: '#dbe9f4'
                                    }}>
                                        <tr>
                                            <th>Check</th>
                                            <th>Post</th>
                                            <th className='text-center'>Dist./Zone Applying For</th>
                                            <th className='text-center'>Local Dist./Zone : No. of Posts</th>
                                            <th className='text-center'>Non-Local Dist./Zone : Max No. of Posts</th>
                                            <th className='text-center'>Available Posts in other Dist./Zone</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {postData?.map((data, index) => {
                                            return (
                                                <tr key={index} id={index} style={{ background: data?.paid_dist_code !== null ? `#a5820726` : '' }}>
                                                    <td className='text-center'>{
                                                        data?.paid_dist_code !== null ?
                                                            <IoMdCheckboxOutline color='green' size={20} /> :
                                                            <Field
                                                                name={`postDetails[${index}].postCheck`}
                                                                type="checkbox"
                                                                className="form-sub"
                                                                onClick={(e) => {


                                                                    if (e.target.checked) {
                                                                        renderDistrictOptions(data, index);
                                                                        Formik.setFieldValue(`postDetails[${index}].postId`, data?.post_id);

                                                                    }
                                                                    else {
                                                                        Formik.setFieldValue(`postDetails[${index}].postId`, '')
                                                                        Formik.setFieldValue(`postDetails[${index}].pstType`, '')
                                                                        SetOptionList(prev => prev.filter(option => option.post_id !== data?.post_id));
                                                                        SetSelectedOption(prev => prev.filter(option => option.post_id !== data?.post_id))
                                                                    }
                                                                    Formik.setFieldValue(`postDetails[${index}].distCode`, '')
                                                                }}
                                                            />
                                                    }
                                                    </td>
                                                    <td style={{ color: 'brown', fontFamily: 'Bold italic' }}><b>{data?.eli_post_name}</b>

                                                    </td>
                                                    <td className='text-center'> {data?.paid_dist_code !== null ? data?.paid_dist_name
                                                        : <>
                                                            <Field as="select" className="form-control"
                                                                name={`postDetails[${index}].distCode`}
                                                                disabled={Formik?.values?.postDetails[index]?.postId === ''}
                                                                onChange={(e) => {
                                                                    const distCodeValue = e.target.value;
                                                                    const distCodeInt = parseInt(distCodeValue);
                                                                    // let datasss = JSON.parse(data?.districts_json)[0]
                                                                    // console.log("daataaa",datasss?.filter((val)=>val?.dist_code === parseInt(e.target.value)))
                                                                    let json_dist = showDist[index]?.filter((val) => val?.dist_code == distCodeValue)[0]
                                                                    let pst_type = json_dist?.post_type;
                                                                    // console.log("psttype",pst_type,json_dist)
                                                                    Formik.setFieldValue(`postDetails[${index}].pstType`, pst_type)
                                                                    SetOptionList(prev => prev.filter(option => option.post_id !== data?.post_id));
                                                                    SetSelectedOption(prev => prev.filter(option => option.post_id !== data?.post_id))
                                                                    // Parse JSON district data
                                                                    const allDistricts = JSON.parse(data?.districts_json)?.[0] || [];

                                                                    const filtered = {
                                                                        state: allDistricts.filter(v => v.post_type === 'S'),
                                                                        Z1: allDistricts.filter(v => v.dist_code === 'Z1'),
                                                                        Z2: allDistricts.filter(v => v.dist_code === 'Z2'),
                                                                        Z3: allDistricts.filter(v => v.dist_code === 'Z3'),
                                                                        Z4: allDistricts.filter(v => v.dist_code === 'Z4'),
                                                                    };

                                                                    // Determine zone status
                                                                    const Z1_status = getZoneStatus(zones, distCodeInt, 'Z1');
                                                                    const Z2_status = getZoneStatus(zones, distCodeInt, 'Z2');
                                                                    const Z3_status = getZoneStatus(zones, distCodeInt, 'Z3');
                                                                    const Z4_status = getZoneStatus(zones, distCodeInt, 'Z4');

                                                                    if (filtered.state.length > 0) {
                                                                        getOptions(0, data, SetOptionList);       // For state-level posts
                                                                    }
                                                                    if (Z1_status && filtered.Z1.length > 0) {

                                                                        getOptions('Z1', data, SetOptionList);    // For Z1 zone
                                                                    }
                                                                    if (Z2_status && filtered.Z2.length > 0) {
                                                                        getOptions('Z2', data, SetOptionList);    // For Z2 zone
                                                                    }
                                                                    if (Z3_status && filtered.Z3.length > 0) {
                                                                        getOptions('Z3', data, SetOptionList);    // For Z3 zone
                                                                    }
                                                                    if (Z4_status && filtered.Z4.length > 0) {
                                                                        getOptions('Z4', data, SetOptionList);    // For Z3 zone
                                                                    }



                                                                    getOptions(distCodeValue, data, SetOptionList);
                                                                    let local_List = data?.local_dist_posts?.split('<br/>') || [];

                                                                    // Get the selected district name (e.g., from a dropdown or form)
                                                                    let e_local = String(json_dist?.dist_name || '').trim();

                                                                    // Check if the selected district is found in any of the local list lines
                                                                    let isLocal = local_List.some(item => {
                                                                        const areaName = item.split(':')[0]?.trim();
                                                                        return areaName === e_local;
                                                                    });
                                                                    // console.log("local",isLocal , local_List ,e_local)
                                                                    if (!isLocal) {
                                                                        Sweetalert(`You have selected Non-Local Post`, 'info');
                                                                    }
                                                                }}
                                                            ><option value="">--Select--</option>
                                                                {showDist[index]?.map((item, i) => (
                                                                    <option key={i} value={item?.dist_code}>
                                                                        {item?.dist_name}
                                                                    </option>
                                                                ))}

                                                            </Field>

                                                            <ErrorMessage
                                                                name={`postDetails[${index}].distCode`}
                                                                component="div"
                                                                className="text-error"
                                                            />

                                                        </>
                                                    }
                                                    </td>
                                                    <td className='text-center'>{data?.local_dist_posts ? data?.local_dist_posts.split('<br/>')
                                                        .map((val, index) => { return (<span key={index}>{val}<br /></span>) })
                                                        : '-'}</td>
                                                    <td className='text-center'>{data?.top_dist_posts ? data?.top_dist_posts.split('<br/>')
                                                        .map((val, index) => { return (<span key={index}>{val}<br /></span>) })
                                                        : '-'}</td>
                                                    <td className='text-end'>
                                                        <button className='btn btn-outline-light' type='button'
                                                            style={{ fontSize: "14px", border: "2px solid #198f85", color: 'black' }}

                                                            onClick={() => {
                                                                setPostName(data?.eli_post_name)
                                                                // let filter_data = JSON.parse(data?.districts_json)[0].filter((val) => val.open_no_of_posts !== 0)
                                                                let filter_data = JSON.parse(data?.districts_json)[0]

                                                                if (filter_data?.length > 0) {
                                                                    setShow(true)

                                                                    setMoreDist(filter_data)
                                                                }
                                                                else {
                                                                    Sweetalert(`No Dist./Zone Available to ${data?.eli_post_name}`, "warning")
                                                                }


                                                            }}>
                                                            VIEW MORE <FaCircleChevronRight style={{ fontSize: "21px" }} color='#198f85' /></button></td>

                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                    <tfoot>
                                        <tr className='text-center'>
                                            <th colSpan={6}>
                                                {(previousPostCount > 0 && (parseInt(AlPaidPostCount) - parseInt(previousPostCount) > 0)) ?
                                                    <> You have already applied for {AlPaidPostCount - previousPostCount} posts.&nbsp;</>
                                                    : ''}
                                                {selectedPostCount > 0 && (<> you are now applying for {selectedPostCount}&nbsp;posts<span style={{ color: "green" }}>
                                                    &nbsp; ({parseInt(selectedPostCount) * 750} Rs.) </span>
                                                </>)}
                                                <pre />
                                                {(parseInt(selectedPostCount) - parseInt(previousPostCount)) > 0 ? (<>
                                                    You have to Pay an amount of  <span style={{ color: "green" }}>&nbsp;
                                                        {(parseInt(selectedPostCount) - parseInt(previousPostCount)) * 750} Rs. </span> &nbsp;
                                                    <span className='blink-color'
                                                    > PAYMENT</span>

                                                </>) :
                                                    (<>
                                                        {(parseInt(previousPostCount) - parseInt(selectedPostCount)) > 0 && (<>
                                                            Balance Amount   : <span style={{ color: "green" }}>&nbsp;
                                                                {(parseInt(previousPostCount) - parseInt(selectedPostCount)) * 750}  Rs.</span> &nbsp;
                                                        </>)}
                                                    </>)

                                                }

                                            </th>

                                        </tr>

                                    </tfoot>
                                </table>
                            </Col>
                        </Row>
                    </div>
                    <div className="personal-head mt-3">
                        <span>Post & Management Preferences</span>
                    </div>
                    <div className="personal-row pb-3">
                        <Weboptions OptionList={OptionList} hideSubmit={hideSubmit} SetOptionList={SetOptionList} SetSelectedOption={SetSelectedOption} SelectedOption={SelectedOption} />
                    </div>

                    <ExamCenters Formik={Formik} Data={examCenterData} />

                    {hideSubmit === false &&
                        <Row className='pb-4'>
                            {showOtp === true &&
                                <React.Fragment>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3}></Col>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                        {resendOtp === true ? <React.Fragment>
                                            <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>&emsp;
                                            <Button variant="primary" type="button" className="" onClick={() => { resendOTP() }}>Resend OTP </Button>
                                        </React.Fragment>
                                            : ''}
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                        <React.Fragment>
                                            <p>
                                                Time Remaining:  {formatTime(timer)}
                                            </p>
                                        </React.Fragment>
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                        <Form.Group controlId="otp">
                                            <Field
                                                type="text"
                                                name="otp"
                                                className="input-field form-control"
                                                placeholder="Enter OTP"
                                                maxLength={6}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                        <div className='float-end'>
                                            <Button variant="success" type="button" className="submit-btn btn-success" onClick={() => { SubmitPostValues() }}>
                                                {Formik?.values?.payment > 0 ? 'Proceed to Pay & Submit' : 'Submit'}
                                            </Button>
                                        </div>
                                    </Col>
                                </React.Fragment>}
                            {showOtp === false && <React.Fragment>
                                <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}></Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-2'>
                                    <div className='float-end'><Button variant="primary" type="submit" className="submit-btn btn-primary"> Generate OTP </Button></div>
                                </Col>
                            </React.Fragment>}
                        </Row>}


                </Form>
            </FormikProvider>

        </React.Fragment>
    )
}
